import { Button } from "@/components/ui/button";
import {
  Form,
  FormControl,
  FormField,
  FormItem,
  FormLabel,
  FormMessage,
} from "@/components/ui/form";
import { Input } from "@/components/ui/input";
import { Eye, EyeOff, Loader2 } from "lucide-react";
import { useState } from "react";
import { useForm } from "react-hook-form";
import { useChangePassword } from "../_misc/mutations";
import { useNavigate } from "react-router-dom";
import { useToken } from "@/hooks/useToken";
import { useAdminDetail } from "@/hooks/useAdminDetail";

const ChangePassword = () => {
  const navigate = useNavigate();
  const { removeAdminLogin } = useAdminDetail();
  const { removeToken } = useToken();
  const [showPassword, setShowPassword] = useState({
    oldPassword: false,
    newPassword: false,
    confirmPassword: false,
  });
  const form = useForm({
    defaultValues: {
      oldPassword: "",
      newPassword: "",
      confirmPassword: "",
    },
  });

  const { mutateAsync: changePassword, isPending } = useChangePassword({
    onSuccess: () => {
      removeToken();
      removeAdminLogin();
      navigate("/");
    },
  });

  const onSubmit = (data: any) => {
    changePassword({
      oldPassword: data.oldPassword,
      newPassword: data.newPassword,
    });
  };
  return (
    <div className="container mx-auto">
      <div className="flex justify-center items-center">
        <h1 className="text-2xl">Change Password</h1>
      </div>
      <div className=" !text-[#333333] w-[500px] mx-auto mt-6">
        <Form {...form}>
          <form onSubmit={form.handleSubmit(onSubmit)} className="space-y-4">
            <FormField
              control={form.control}
              name="oldPassword"
              render={({ field }) => (
                <FormItem>
                  <FormLabel>Current Password</FormLabel>
                  <FormControl>
                    <div className="relative w-full">
                      <Input
                        type={showPassword.oldPassword ? "text" : "password"}
                        placeholder="*********"
                        className="pr-10 h-12"
                        {...field}
                      />
                      <button
                        type="button"
                        onClick={() =>
                          setShowPassword((old) => ({
                            ...old,
                            oldPassword: !old.oldPassword,
                          }))
                        }
                        className="absolute right-3 top-1/2 -translate-y-1/2 text-gray-500 hover:text-gray-700"
                      >
                        {showPassword.oldPassword ? (
                          <EyeOff className="h-4 w-4" />
                        ) : (
                          <Eye className="h-4 w-4" />
                        )}
                      </button>
                    </div>
                  </FormControl>
                  <FormMessage />
                </FormItem>
              )}
            />

            <FormField
              control={form.control}
              name="newPassword"
              render={({ field }) => (
                <FormItem>
                  <FormLabel>New Password</FormLabel>
                  <FormControl>
                    <div className="relative w-full">
                      <Input
                        type={showPassword.newPassword ? "text" : "password"}
                        placeholder="*********"
                        className="pr-10 h-12" // Add padding for the icon
                        {...field}
                      />
                      <button
                        type="button"
                        onClick={() =>
                          setShowPassword((old) => ({
                            ...old,
                            newPassword: !old.newPassword,
                          }))
                        }
                        className="absolute right-3 top-1/2 -translate-y-1/2 text-gray-500 hover:text-gray-700"
                      >
                        {showPassword.newPassword ? (
                          <EyeOff className="h-4 w-4" />
                        ) : (
                          <Eye className="h-4 w-4" />
                        )}
                      </button>
                    </div>
                  </FormControl>
                  <FormMessage />
                </FormItem>
              )}
            />

            <FormField
              control={form.control}
              name="confirmPassword"
              render={({ field }) => (
                <FormItem>
                  <FormLabel>Confirm New Password</FormLabel>
                  <FormControl>
                    <div className="relative w-full">
                      <Input
                        type={
                          showPassword.confirmPassword ? "text" : "password"
                        }
                        placeholder="*********"
                        className="pr-10 h-12" // Add padding for the icon
                        {...field}
                      />
                      <button
                        type="button"
                        onClick={() =>
                          setShowPassword((old) => ({
                            ...old,
                            confirmPassword: !old.confirmPassword,
                          }))
                        }
                        className="absolute right-3 top-1/2 -translate-y-1/2 text-gray-500 hover:text-gray-700"
                      >
                        {showPassword.confirmPassword ? (
                          <EyeOff className="h-4 w-4" />
                        ) : (
                          <Eye className="h-4 w-4" />
                        )}
                      </button>
                    </div>
                  </FormControl>
                  <FormMessage />
                </FormItem>
              )}
            />

            <Button
              disabled={isPending}
              isLoading={isPending}
              type="submit"
              className="bg-primary-100 w-full h-12 py-2"
            >
              {isPending ? <Loader2 className="animate-spin" /> : "Submit"}
            </Button>
          </form>
        </Form>
      </div>
    </div>
  );
};

export default ChangePassword;
